import { dealsDuckCreator } from 'axl-ducks';

export default dealsDuckCreator();
